<button mat-button color="warn" (click)="logout()">Logout</button>